module.exports = __webpack_public_path__ + "img/num-04.202fcfb4.png";